import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Paper from "@material-ui/core/Paper";
import AddAlertIcon from "@material-ui/icons/AddAlert";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import DescriptionIcon from "@material-ui/icons/Description";
import _ from "lodash";
import { fetchFunds, downloadFunds } from "store/state/fund";
import { openNotes } from "store/state/note";

import { ToastSuccess, ToastError } from "components/Global/Toasts/Toasty";

//Screen Preference Impoorts
import EnhancedTableHead from "components/Global/Table/EnhancedTableHead";
import { getScreenPreferences } from "../../../shared-utility/store/state/screenPreferences";
import { default as TableScreenElements } from "components/Global/TablePreferenceColumns/FundTableColumns/FundTableColumns";
import BuildColumns from "components/Global/TablePreferenceColumns/BuildColumns";
import { CircularProgress } from "@material-ui/core";
import TablePaginationHelper from "../../../utils/tablePaginationHelper";

const screenType = "fund_table";

class FundsList extends React.Component {
  state = {
    funds: null,
    order: null,
    orderBy: null,
    orderDir: "desc",
    resetOrder: false,
    selected: [],
    update: 0
  };
  columns = [];
  tablePaginationHelper = new TablePaginationHelper("beb6c7c5-981e-4248-bb47-c013e07f4e9a", 10);

  componentWillMount() {
    this.props.fetchFunds({
      page: this.tablePaginationHelper.page,
      limit: this.tablePaginationHelper.rowsPerPage,
      orderField: null,
      orderDir: "desc"
    });
  }

  componentDidMount() {
    this.props.getScreenPreferences({
      screenType
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.funds === null && this.props.fund.funds !== null && prevProps.fund.funds !== this.props.fund.funds){
      this.setState({
        funds: this.props.fund.funds,
        order: this.props.fund.order,
      });
    }
  }

  isPageLoadCircleShowing = () => {
    let loading = this.props.loading;
    if (
      loading.deal ||
      loading.users ||
      loading.authentication ||
      loading.funds ||
      loading.property ||
      loading.loan ||
      loading.avp ||
      loading.bankSwap ||
      loading.cashFlows ||
      loading.pipeline || 
      loading.capPricer      
      ) return true
      else return false;
  }

  getRows = (funds, order) => {
    const { page, rowsPerPage } = this.tablePaginationHelper;
    // funds is initially an array but turns into a json object upon receiving data from api. this means we dont have to check length===0, which would
    // give a false positive in the even that there are actually no funds in the portfolio
    if((!funds || Array.isArray(funds)) && !this.isPageLoadCircleShowing()) 
      return <TableRow style={{textAlign: "center"}}><td colSpan={7}><CircularProgress style={{margin: "10px"}}/></td></TableRow>
    
    const pagePlus = page + 1;
    const start = (pagePlus - 1) * rowsPerPage;
    const end = pagePlus * rowsPerPage; 
    const paged = order.slice(start, end);

    return paged.map(key => (
      <TableRow key={key} hover>
        {this.columns.map(({ id, Cell }) => (
          <Cell key={id} fund={funds[key]} />
        ))}
      </TableRow>
    ));
  }

  render() {
    const { rowsPerPage, page } = this.tablePaginationHelper;
    const { funds, order, orderDir, orderBy, selected } = this.state;
    const { count } = this.props.fund;

    BuildColumns(
      this.props.screenPreferenceList,
      TableScreenElements,
      this.columns
    );

    if (this.columns.length > 0) {
      return (
        <Fragment>
          <Paper elevation={0} style={{ backgroundColor: "transparent" }}>
            {funds ? (
              <React.Fragment>
                <Table 
                  className="loansList_Table _tableClosedFundList tableBlueHover" 
                  id="fundListTable">
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={orderDir}
                    orderBy={orderBy}
                    onRequestSort={this.handleRequestSort}
                    rowCount={count}
                    columns={this.columns}
                    metrics={this.props.screenPreferenceList}
                    screenType={screenType}
                    shouldHideExport={true}
                    onClose={() => {
                      this.columns = [];
                    }}
                    downloadFunds={this.props.downloadFunds}
                  />
                  <TableBody>{this.getRows(funds, order)}</TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        className="table-pagination"
                        colSpan={selected.length}
                        count={count}
                        rowsPerPage={rowsPerPage}
                        rowsPerPageOptions={[5, 10, 25, 100]}
                        page={page}
                        backIconButtonProps={{
                          "aria-label": "Previous Page"
                        }}
                        nextIconButtonProps={{
                          "aria-label": "Next Page"
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        labelDisplayedRows={() => `${page + 1} of ${Math.ceil(count / rowsPerPage)}`}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </React.Fragment>
            ) : (
              <div>Loading</div>
            )}
          </Paper>
        </Fragment>
      );
    }
    return null;
  }

  // BEGIN: Table Controls

  handleRequestSort = (event, property) => {
    const {orderBy, orderDir, resetOrder} = this.state;

    let nextOrderBy = property.dataField;
    if (nextOrderBy) {
      let nextOrder = "desc";      
      if ( orderDir === "desc" && !resetOrder) {
        nextOrder = "asc";        
      } else if (orderDir === "asc" && !resetOrder) {
        nextOrder = "desc";
        this.setState({
          resetOrder: true
        });        
      } else if (orderDir === "desc" && resetOrder) {
        nextOrder = "desc";
        nextOrderBy = null; 
        this.setState({
          resetOrder: false
        });
      }
      let order = _.orderBy(this.props.fund.all, [nextOrderBy], [nextOrder.toLowerCase()]).map(fund => fund.id);
      this.setState({ orderDir: nextOrder.toLowerCase(), orderBy:nextOrderBy, page: 0, order  });
    }
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, newPage) => {
    this.tablePaginationHelper.page = newPage;
    this.forceUpdate();
  };

  handleChangeRowsPerPage = event => {
    this.tablePaginationHelper.rowsPerPage = event.target.value;
    this.forceUpdate();
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  // END: Table Controls

  notify = (notifyState, reason) =>
    ToastError(
      <Fragment>
        <strong>{notifyState}</strong> has been {reason}
      </Fragment>
    );
}

const mapStateToProps = ({ fund, screenPreferences, loading }) => ({
  fund,
  refreshFunds: fund.refreshFunds,
  screenPreferenceList: screenPreferences.screen_pref.fund_table || null,
  loading,
});

export default connect(
  mapStateToProps,
  { fetchFunds, downloadFunds, openNotes, getScreenPreferences }
)(FundsList);
